// extracted by mini-css-extract-plugin
export default {"box":"Annotation_box__zpU5q","flareAnimation":"Annotation_flareAnimation__BbT-w","shine":"Annotation_shine__HpoKE"};